import { baseUrl } from "../config/config";
import axios from 'axios';

// get all Don
export const getAllDon = async () => {
  try {
    const response = await axios.get(`${baseUrl}/don`);
    return response.data;
  } catch (error) {
    console.error('erreur get all Don:', error);
    return [];
  }
}

// get Don by Id
export const getDonByUserId = async (user_id) => {
  try {
    const response = await axios.get(`${baseUrl}/don/${user_id}`);
    return response.data;
  } catch (error) {
    console.error(`erreur get Don by Id ${user_id}:`, error);
    return null;
  }
}

// add Don
// export const addDon = async (don) => {
//   try {
//     const response = await axios.post(`${baseUrl}/don/faire_un_don`, don);
//     return response;
//   } catch (error) {
//     console.error( "erreur lors de l'ajout du Don", error);
//     return [];
//   }
// }

// delete Don by Id
// export const deleteDonById = async (id) => {
//   try {
//     const response = await axios.delete(`${baseUrl}/don/${id}`);
//     return response;
//   } catch (error) {
//     console.error(`erreur lors de la supression du Don ${id}:`, error);
//     return null;
//   }
// }
